var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.sendForm($event)
        }
      }
    },
    [
      _c("div", { staticClass: "container mb-4" }, [
        _c("div", { staticClass: "k-panel k-panel--grid" }, [
          _c(
            "div",
            { staticClass: "k-panel__body k-panel__body--2-3 k-border-right" },
            [
              _c("h3", { staticClass: "k-h-tertiary k-mb-30" }, [
                _vm._v("Základní údaje")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "k-form" }, [
                _c(
                  "div",
                  { staticClass: "k-form__group" },
                  [
                    _c(
                      "label",
                      { staticClass: "k-form__label k-form__label--required" },
                      [_vm._v("Název příspěvku")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.title,
                          expression: "form.title"
                        }
                      ],
                      staticClass: "k-form__input",
                      attrs: {
                        type: "text",
                        placeholder: "Zadejte název příspěvku"
                      },
                      domProps: { value: _vm.form.title },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "title", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.form_errors.title
                      ? _c("field-error", [
                          _vm._v(_vm._s(_vm.form_errors.title[0]))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-form__group" },
                  [
                    _c(
                      "label",
                      { staticClass: "k-form__label k-form__label--required" },
                      [_vm._v("Definice problému")]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.content,
                          expression: "form.content"
                        }
                      ],
                      staticClass: "k-form__textarea",
                      attrs: { placeholder: "Zadejte popis příspěvku" },
                      domProps: { value: _vm.form.content },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "content", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.form_errors.content
                      ? _c("field-error", [
                          _vm._v(_vm._s(_vm.form_errors.content[0]))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c("h3", { staticClass: "k-h-tertiary" }, [
                      _vm._v("Přílohy")
                    ]),
                    _vm._v(" "),
                    _c("drop-zone", {
                      ref: "dropzone",
                      staticClass: "k-dropzone",
                      attrs: {
                        id: "dropzone",
                        options: _vm.dropZoneOptions,
                        "include-styling": false
                      },
                      on: {
                        "vdropzone-complete": _vm.dropZoneFileCompleted,
                        "vdropzone-success": _vm.dropZoneFileSuccess,
                        "vdropzone-removed-file": _vm.dropZoneFileRemoved
                      }
                    }),
                    _vm._v(" "),
                    _vm.form_errors.files
                      ? _c("field-error", [
                          _vm._v(_vm._s(_vm.form_errors.files[0]))
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "k-panel__body k-panel__body--1-3 " }, [
            _c("h3", { staticClass: "k-h-tertiary k-mb-30" }, [
              _vm._v("Parametry")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "k-form__group" },
              [
                _c(
                  "label",
                  {
                    staticClass: "k-form__label k-form__label--required",
                    attrs: { for: "choices-text-remove-button" }
                  },
                  [_vm._v("Klíčová slova")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.keywords,
                      expression: "form.keywords"
                    }
                  ],
                  ref: "keywords",
                  staticClass: "form-control k-choices--multiple",
                  attrs: {
                    id: "choices-text-remove-button",
                    type: "text",
                    placeholder: "Klíčové slovo 1, Klíčové slovo 2,..."
                  },
                  domProps: { value: _vm.form.keywords },
                  on: {
                    change: _vm.keywordAdded,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "keywords", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.form_errors.keywords
                  ? _c("field-error", [
                      _vm._v(_vm._s(_vm.form_errors.keywords[0]))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "k-form__group" },
              [
                _c(
                  "label",
                  { staticClass: "k-form__label k-form__label--required" },
                  [_vm._v("Kategorie")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.subcategories,
                        expression: "form.subcategories"
                      }
                    ],
                    staticClass: "form-control k-choices--multiple",
                    attrs: {
                      name: "choices-multiple-remove-button",
                      placeholder: "This is a placeholder",
                      multiple: ""
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "subcategories",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.categoriesOptions, function(value, index) {
                    return _c("option", { domProps: { value: index } }, [
                      _vm._v(_vm._s(value))
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.form_errors.subcategories
                  ? _c("field-error", [
                      _vm._v(_vm._s(_vm.form_errors.subcategories[0]))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "k-form__group" },
              [
                _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c(
                    "label",
                    { staticClass: "k-form__label k-form__label--required" },
                    [_vm._v("Upozornění")]
                  ),
                  _vm._v(" "),
                  _vm.is_notify_all_btn_visible
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:;" },
                          on: { click: _vm.selectAllNotificationGroups }
                        },
                        [_vm._v("Vybrat všechny")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.form.notifications,
                        expression: "form.notifications",
                        modifiers: { number: true }
                      }
                    ],
                    ref: "notificationsInput",
                    staticClass: "form-control k-choices--multiple",
                    attrs: {
                      name: "choices-multiple-remove-button",
                      placeholder: "This is a placeholder",
                      multiple: ""
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return _vm._n(val)
                          })
                        _vm.$set(
                          _vm.form,
                          "notifications",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.notificationsOptions, function(value, index) {
                    return _c("option", { domProps: { value: index } }, [
                      _vm._v(_vm._s(value))
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.form_errors.notifications
                  ? _c("field-error", [
                      _vm._v(_vm._s(_vm.form_errors.notifications[0]))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "k-form__group" },
              [
                _c(
                  "label",
                  { staticClass: "k-form__label k-form__label--required" },
                  [_vm._v("Status příspěvku")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.status_id,
                        expression: "form.status_id"
                      }
                    ],
                    staticClass: "form-control k-choices--multiple",
                    attrs: { name: "choices-single-no-search" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "status_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { placeholder: "", value: "" } }, [
                      _vm._v("Vyberte status")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.statuses, function(value, index) {
                      return _c("option", { domProps: { value: index } }, [
                        _vm._v(_vm._s(value))
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.form_errors.status_id
                  ? _c("field-error", [
                      _vm._v(_vm._s(_vm.form_errors.status_id[0]))
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "k-panel__footer justify-content-between align-items-center"
      },
      [
        _c("div", { staticClass: "k-panel__footer-btn" }, [
          _c("button", { staticClass: "k-btn k-btn--primary" }, [
            _vm._v("\n                        Uložit\n                    ")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }